import { render, staticRenderFns } from "./statewide-main.vue?vue&type=template&id=a1fcbb32&scoped=true"
import script from "./statewide-main.vue?vue&type=script&lang=js"
export * from "./statewide-main.vue?vue&type=script&lang=js"
import style0 from "./statewide-main.vue?vue&type=style&index=0&id=a1fcbb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fcbb32",
  null
  
)

export default component.exports